import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styled from 'styled-components';
import { useState } from 'react';

interface ImgItem {
  imgNo: string;
  src: string;
  description?: string;
}

interface Props {
  imgList: ImgItem[];
}

const ImgSlider = ({ imgList }: Props) => {
  const [currentpage, setCurrentPage] = useState(1);

  const setting = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    afterChange: (current: number) => setCurrentPage(current + 1),
  };

  return (
    <Container>
      <ImgBox>
        <Slider {...setting}>
          {imgList.map((img) => (
            <div key={img.imgNo}>
              <img
                src={`${process.env.REACT_APP_HOST_API}img/${img.src}`}
                alt={img.description || 'Image'}
                style={{
                  width: '100%',
                  height: '360px',
                  contain: 'cover',
                  // objectFit: 'cover',
                }}
              />
            </div>
          ))}
        </Slider>
      </ImgBox>
      <PageNumber>
        <span style={{ color: 'white' }}>{currentpage} </span>
        <span>/</span>
        <span>{imgList.length}</span>
      </PageNumber>
      <style>
        {`
    .slick-prev, .slick-next {
      z-index: 10;
      width: 40px;
      height: 40px;
    }
    .slick-prev {
      left: 6px;
    }
    .slick-next {
      right: 6px;
    }
  `}
      </style>
    </Container>
  );
};

export default ImgSlider;

const Container = styled.div`
  width: 100%;
  position: relative;
`;

const ImgBox = styled.div`
  width: 100%;
  height: 310px;
`;

const PageNumber = styled.div`
  height: 25px;
  position: absolute;
  bottom: 16px;
  right: 16px;
  padding: 4px 10px;
  font-size: 12px;
  background-color: rgba(0, 0, 0, 0.78);
  border-radius: 999px;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: -0.24px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 2px;
`;
